import { render } from "./SchoolAccountManagement.vue?vue&type=template&id=5a40af49&scoped=true"
import script from "./SchoolAccountManagement.vue?vue&type=script&lang=js"
export * from "./SchoolAccountManagement.vue?vue&type=script&lang=js"

import "./SchoolAccountManagement.vue?vue&type=style&index=0&id=5a40af49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a40af49"]])

export default __exports__